import Breadcrumb from "../components/Breadcrumb";
import VehicleTypesLayer from "../components/VehicleTypesLayer";
import ViewClientLayer from "../components/ViewClientlayer";

const VehicleTypesPage = () => {
  return (
    <>
      {/* Breadcrumb */}
      <Breadcrumb title="Vehicle Types" />

      < VehicleTypesLayer/>
    </>
  );
};

export default VehicleTypesPage;
